import { render, staticRenderFns } from "./classifyAdd.vue?vue&type=template&id=4beb8b16&scoped=true"
import script from "./classifyAdd.vue?vue&type=script&lang=js"
export * from "./classifyAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb8b16",
  null
  
)

export default component.exports